import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CategoriesTab = ({ categories, onRefresh }) => {
  const [newCategoryName, setNewCategoryName] = useState('');

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCategoryName.trim()) return;
    try {
      await axios.post(`${API}/categories`, { name: newCategoryName.trim() });
      toast.success('Category added');
      setNewCategoryName('');
      onRefresh();
    } catch (error) { toast.error(error.response?.data?.detail || 'Failed to add category'); }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await axios.delete(`${API}/categories/${categoryId}`);
      toast.success('Category deleted');
      onRefresh();
    } catch { toast.error('Failed to delete category'); }
  };

  return (
    <div>
      <h2 className="text-2xl font-normal mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Manage Categories</h2>
      <p className="text-sm text-gray-400 mb-8">Add or remove categories used for gallery photos and the contact form service dropdown.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div className="border border-white/10 p-8">
          <h3 className="text-lg font-normal mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Add Category</h3>
          <form onSubmit={handleAddCategory} className="flex gap-4" data-testid="add-category-form">
            <input type="text" value={newCategoryName} onChange={(e) => setNewCategoryName(e.target.value)} placeholder="Category name" className="flex-1 bg-black border border-white/10 rounded-none px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-white/30 transition-colors" required data-testid="new-category-input" />
            <button type="submit" className="bg-white text-black hover:bg-gray-200 rounded-none px-6 py-3 text-sm uppercase tracking-widest transition-all duration-300" data-testid="add-category-btn">Add</button>
          </form>
        </div>
        <div className="border border-white/10 p-8">
          <h3 className="text-lg font-normal mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Current Categories</h3>
          {categories.length === 0 ? (
            <p className="text-gray-400 text-sm">No categories yet.</p>
          ) : (
            <div className="space-y-3">
              {categories.map((cat) => (
                <div key={cat.id} className="flex items-center justify-between border border-white/10 px-4 py-3" data-testid={`category-item-${cat.id}`}>
                  <span className="text-sm tracking-wide">{cat.name}</span>
                  <button onClick={() => handleDeleteCategory(cat.id)} className="text-gray-500 hover:text-red-400 transition-colors" data-testid={`delete-category-${cat.id}`}><Trash2 size={16} /></button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoriesTab;
